/* eslint-disable */


/**
 * Create styles for `<OrderCallButton />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderCallButton />` styles
 */
const orderCallButtonStyles = ({ theme }) => ({
  callBoral: {
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    justifyContent: `left`,
  },
  callIcon: {
    marginLeft: theme.spacing(1),
    transform: `rotate(270deg)`,
  },
  callToAction: {
    borderRadius: theme.shape.borderRadius,
    height: theme.spacing(1) * 7,
    justifyContent: `left`,
  },
});

export default orderCallButtonStyles;
